import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import formatDateTime from "../../../helpers/formatDateTime";
import { VOICE_NOTE_REVISION_LOG } from "../types/CommonTypes";

type RevisedCaseNoteListProps = {
  revisionLogs?: Array<VOICE_NOTE_REVISION_LOG>;
};

export default function RevisedCaseNoteList(
  props: Readonly<RevisedCaseNoteListProps>,
) {
  const { t } = useTranslation();
  const { revisionLogs = [] } = props;
  const updateRevisionCount = revisionLogs.filter(
    (item) => item.action === "UPDATE",
  ).length;

  if (revisionLogs.length === 0) {
    return (
      <Typography
        color="custom.foreground.inactive"
        fontSize={14}
      >
        {t("No_revisions_yet")}
      </Typography>
    );
  }

  return (
    <Box sx={styles.container}>
      {/* Revision History Heading */}
      <Typography sx={styles.historyTitle}>
        {t("Revision_History")} ({updateRevisionCount})
      </Typography>

      {/* Revision List */}
      {revisionLogs.map((item, index) => {
        const revisionTime = item.createdAt;

        return (
          <Box
            key={item.id ?? `${revisionTime ?? "revision"}-${index}`}
            sx={styles.revisionItem}
          >
            {/* Revised Note */}
            <Box sx={styles.noteBox}>
              <Typography sx={styles.noteText}>
                {item.revisedNote || "-"}
              </Typography>
            </Box>

            {/* Revision Information */}
            <Typography sx={styles.revisionMeta}>
              {`${
                item.action === "CREATE" ? t("Created_by") : t("Revised_by")
              } ${item.revisedByUserName ?? "NA"} ${t(
                "at",
              )} ${formatDateTime(revisionTime, true, "hh:mm:ss aaa")}`}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
const styles = {
  container: {
    width: "100%",
  },

  historyTitle: {
    fontSize: "13px",
    fontWeight: 700,
    lineHeight: "18px",
    color: "custom.foreground.primary",
    mb: "8px",
  },

  revisionItem: {
    mb: "10px",

    "&:last-child": {
      mb: 0,
    },
  },

  noteBox: {
    width: "100%",
    boxSizing: "border-box",
    backgroundColor: "#F8FAFD",
    borderRadius: "10px",
    px: "12px",
    py: "10px",
  },

  noteText: {
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 400,
    color: "#344054",
    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere",
  },

  revisionMeta: {
    mt: "6px",
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 400,
    color: "custom.foreground.primary",
  },
};
